export const PORTAL_FEATURE_TOUR = {
  id: "feature_portal",
  steps: [
    {
      element: '[data-tour="integration-portal-config"]',
      popover: {
        title: "Novo: Portal do cliente! 🆕",
        description:
          "Agora seus clientes podem gerenciar a assinatura, trocar de plano e comprar extras por conta própria.",
        side: "left",
      },
    },
    {
      element: '[data-tour="portal-toggles"]',
      popover: {
        title: "Configure o que aparece",
        description:
          "Escolha quais funcionalidades o cliente pode acessar: troca de plano, compra de pacotes, cancelamento, etc.",
        side: "left",
      },
    },
  ],
};
